import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Login } from '../interfaces/beans.interface';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LoginService {

  url = environment.url + '/login';

  constructor(private http: HttpClient) {}

  getLogin(login: Login) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Access-Control-Allow-Origin', environment.urlLocal);
    return this.http.get(`${ this.url }/login?username=${ login.username }&password=${ login.password }`, { headers }).pipe( map( data => data));
  }

  recup(usuario: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Access-Control-Allow-Origin', environment.urlLocal);
    return this.http.get(`${ this.url }/recup?username=${ usuario }`, { headers }).pipe( map( data => data));
  }

}
